import { useEffect, useState } from 'react';
import { isDevMode, isCP } from '@utils/app-utils.js';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo, setAuthorized } from '@reducers/seller-center/userinfo-slice/index.js';
import { getCurrentUserApi } from '@apis/seller-center/profile-settings.js';
import { BASE_PATH, STORE_NOT_FOUND } from '../../constants/seller-center-paths.js';
import { sanitizePathname } from '../../utils/utils.js';

const useKeycloak = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userData);
  const [loading, setLoading] = useState(!isCP());

  useEffect(() => {
    const initKeycloak = async () => {
      try {
        setLoading(true);
        if (isDevMode()) {
          const res = await getCurrentUserApi();
          const currentUser = res?.current_user;
          dispatch(
            setUserInfo({
              authenticated: true,
              initialized: true,
              userProfile: { ...currentUser, image: currentUser?.store?.logo?.sizes?.thumbnail },
              storeId: currentUser?.store?.id,
              admin: res?.admin,
            })
          );
          if (!res?.unauthorized || sanitizePathname(window.location.pathname) === `${BASE_PATH}${STORE_NOT_FOUND}`)
            setLoading(false);
        } else {
          let authenticated = true;
          if (authenticated) {
            const res = await getCurrentUserApi();
            const currentUser = res?.current_user;
            dispatch(
              setUserInfo({
                authenticated: authenticated,
                initialized: true,
                userProfile: { ...currentUser, image: currentUser?.store?.logo?.sizes?.thumbnail },
                storeId: currentUser?.store?.id,
                admin: res?.admin,
              })
            );
          }
        }
      } catch (e) {
        dispatch(setAuthorized(false));
      } finally {
        setLoading(false);
      }
    };

    !isCP() && initKeycloak();
  }, []);

  return { userInfo, keycloakLoading: loading };
};

export default useKeycloak;
